{
  "browserNotSupported": {
    "title": "A modult nem lehetett betölteni",
    "text": "Az alkatrészböngésző használatához váltson egy naprakész böngészőre."
  },
  "main": {
    "more": "További kiegészítők",
    "findMore": "Gépjárművének utólagos felszereléséhez/átalakításához és korszerűsítéséhez szükséges tartozékokat itt találhat széles kínálatunkban. Az Ön által kiválasztott tartozékokat a járműigényléssel együtt elküldjük {{brand}}-partnerének.",
    "topOffers": "LEGJOBB ajánlatok",
    "article": "<0>{{min}} - {{max}} / </0>{{productCount}} Termék",
    "noArticleFound": "0 Termék",
    "oemHint": "Válassza ki a megfelelő kiegészítőket a {{brand}}-hez most!",
    "noBrand": "Válassza ki a megfelelő tartozékokat járművéhez most!",
    "outOfOrder": "Jelenleg sajnos nem állnak rendelkezésre termékek.<0/>Jelenleg frissítjük katalógusunkat.<0/>Kérjük, látogasson el hozzánk egy későbbi időpontban.",
    "nextSlide": "Következő",
    "prevSlide": "Előző"
  },
  "cart": {
    "add": "A termék hozzáadva a járműhöz",
    "fullPrice": "Jármű és tartozékok ára",
    "priceWithoutCar": "Árak tartozékok"
  },
  "navigation": {
    "zoom": "Nagyítás",
    "toggleSearch": "Keresés váltása",
    "cart": "Kosár",
    "cartDelete": "Termék eltávolítása a kosárból",
    "vehicle": "Kiválasztott jármű",
    "maxBookmarksReached": "Maximum 15 termék érhető el",
    "filter": {
      "toggleFilter": "Szűrő váltása",
      "topProducts": "LEGJOBB ajánlatok",
      "reset": "Szűrő visszaállítása",
      "ready": "Kész",
      "show": "Eredmények megjelenítése"
    },
    "searching": {
      "submit": "Keresés",
      "close": "Bezár",
      "placeholder": "Megfelelő kiegészítők keresése ...",
      "suggestions": "Keresési javaslatok",
      "categories": "Kategóriák",
      "products": "Termékek",
      "productCount": "{{count}} termék",
      "productCount_other": "{{count}} termék",
      "showAll": "{{count}} találat megjelenítése",
      "showAll_other": "Mind a(z) {{count}} találat megjelenítése",
      "expand": "Bővített keresés",
      "show": "Eredmények megjelenítése",
      "found": {
        "withCategory": "A \"{{fuzzy}}\" keresési eredményei a \"{{category}}\" kategóriában",
        "withOutCategory": "Search results for \"{{fuzzy}}\" from all categories"
      }
    },
    "share": "Megosztás",
    "back": "Vissza",
    "details": "Részletek",
    "add": "Hozzáadás",
    "remove": "Eltávolítás",
    "close": "Bezárás",
    "filtern": "Szűrő",
    "closeFilter": "Szűrő bezárása"
  },
  "productDetail": {
    "gallery": {
      "jumpToImageNumber": "Ugrás a(z) {{number}}. képre"
    },
    "articleNumber": "Cikkszám",
    "relatedArticle": "Ezek a termékek is érdekelhetik:",
    "brand": "Márka",
    "priceBox": {
      "withVatAndMounting": "áfával & összeszereléssel együtt",
      "withVat": "áfával együtt",
      "recommendedRetailPrice": "Ajánlott kiskereskedelmi ár",
      "historicMinimalPurchasePrice": "Legalacsonyabb ár az elmúlt 30 napban",
      "priceDetails": "Árinformációk",
      "priceDetailsHeadline": "A termék árával kapcsolatos részletek",
      "priceToday": "A termék mai ára",
      "priceDetails30Days": "Legalacsonyabb ár az árváltozást megelőző 30 napban",
      "close": "Bezárás",
      "addItem": "Cikk hozzáadása",
      "removeItem": "Cikk eltávolítása"
    },
    "infoBox": {
      "description": "Leírás",
      "vehicles": "Alkalmas a következő modellekhez",
      "empty": "Ehhez a termékhez nincsenek speciális járműbeosztások.",
      "contacts": "Gyártó"
    },
    "contacts": {
      "manufacturer-contact": "Gyártó elérhetőségei",
      "responsible-contact": "Felelős személy az EU-ban",
      "trademark": "Márka"
    }
  },
  "productList": {
    "oemHint": "Eredeti tartozékok a(z) {{brand}}"
  }
}
